export class SelectedEmployee {
  public constructor (
    readonly id: number | undefined,
    readonly name: string,
    readonly capacity: string | undefined,
    readonly isFloater: boolean,
    readonly planningGroupName: string | undefined,
    readonly medicalCertificate: boolean,
    readonly medicalCertificateValid:  Date | undefined,
    readonly comment: string,
    readonly start: Date,
    readonly end: Date,
    readonly number: number | undefined,
    readonly detailId?: number
  ) {}

  public updateComment (comment: string): SelectedEmployee {
      return new SelectedEmployee(
        this.id,
        this.name,
        this.capacity,
        this.isFloater,
        this.planningGroupName,
        this.medicalCertificate,
        this.medicalCertificateValid,
        comment,
        this.start,
        this.end,
        this.number,
        this.detailId
      )
  }

  public updateMedicalCertificate (medicalCertificate: boolean): SelectedEmployee {
    return new SelectedEmployee(
      this.id,
      this.name,
      this.capacity,
      this.isFloater,
      this.planningGroupName,
      medicalCertificate,
      this.medicalCertificateValid,
      this.comment,
      this.start,
      this.end,
      this.number,
      this.detailId
    )
  }

  public updateMedicalCertificateValid (medicalCertificateValid: Date | undefined): SelectedEmployee {
    return new SelectedEmployee(
      this.id,
      this.name,
      this.capacity,
      this.isFloater,
      this.planningGroupName,
      this.medicalCertificate,
      medicalCertificateValid,
      this.comment,
      this.start,
      this.end,
      this.number,
      this.detailId
    )
  }

}
